/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
        <vx-card class="mb-base">
          <h3 class="font-semibold mb-4">Step Completion</h3>
          <div :class="completion.step1 ? 'text-success' : ''" class="vx-row mb-5">
            <div class="vx-col w-1/5 p-0 align-middle flex">
              <feather-icon v-if="completion.step1" :icon="'CheckCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
              <feather-icon v-else :icon="'XCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
            </div>
            <div class="w-4/5">
              <p class="text-xl font-bold my-1 ubuntu-font">Step 1</p>
              <p class="text-xl text-grey font-semibold my-1 ubuntu-font">Install the Service</p>
            </div>
          </div>
          <div :class="completion.step2 ? 'text-success' : ''" class="vx-row mb-5">
            <div class="vx-col w-1/5 p-0 align-middle flex">
              <feather-icon v-if="completion.step2" :icon="'CheckCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
              <feather-icon v-else :icon="'XCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
            </div>
            <div class="w-4/5">
              <p class="text-xl font-bold my-1 ubuntu-font">Step 2</p>
              <p class="text-xl text-grey font-semibold my-1 ubuntu-font">Start the Service</p>
            </div>
          </div>
          <div :class="completion.step3 ? 'text-success' : ''" class="vx-row mb-5">
            <div class="vx-col w-1/5 align-middle p-0 flex">
              <feather-icon v-if="completion.step3" :icon="'CheckCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
              <feather-icon v-else :icon="'XCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
            </div>
            <div class="w-4/5">
              <p class="text-xl font-bold my-1 ubuntu-font">Step 3</p>
              <p class="text-xl text-grey font-semibold my-1 ubuntu-font">Enable the Service</p>
            </div>
          </div>
          <div :class="completion.step4 ? 'text-success' : ''" class="vx-row">
            <div class="vx-col w-1/5 p-0 align-middle flex">
              <feather-icon v-if="completion.step4" :icon="'CheckCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
              <feather-icon v-else :icon="'XCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
            </div>
            <div class="w-4/5">
              <p class="text-xl font-bold my-1 ubuntu-font">Step 4</p>
              <p class="text-lg text-grey font-semibold my-1 ubuntu-font">Verify the Service is Active</p>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-9/12 md:w-8/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command
            id="command_prompt"
            :commands="commands"
            :prompt="'[root@centos7]#'"
            :show-intro="true"
            class=""
            intro="CentOS Linux 7 (Core)"
            style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem"
            title="CentOS Shell"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      completion: {
        step1: false,
        step2: false,
        step3: false,
        step4: false,
      },

      commands: {
        mema: () => createStdout('Is the best developer in the world'),
        help: () =>
          createStdout(
            'Available commands:<br>&nbsp;yum install [package]<br>&nbsp;systemctl [action] [service]',
          ),
        yum: () => undefined,
        systemctl: () => undefined,
      },
    };
  },
  methods: {},
  components: {
    Prism,
    VueCommand,
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    //Disable Mark Button and Update Options in Renderer
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);

    this.commands.yum = (x) => {
      if (x._[1] !== 'install' || x._[2] === undefined) {
        return createStderr('Invalid Usage: yum install [package]');
      }

      if (x._[2] === 'httpd') {
        this.completion.step1 = true;
        return createStdout(
          'Loaded plugins: fastestmirror<br>Resolving Dependencies<br>--> Running transaction check<br>---> Package httpd.x86_64 0:2.4.6-97.el7.centos will be installed<br>Running transaction<br>Installing : httpd-2.4.6-97.el7.centos.x86_64<br>Complete!',
        );
      }

      return createStdout('Package Not Found');
    };
    this.commands.systemctl = (x) => {
      const allowed_methods = ['start', 'enable', 'status'];

      if (!allowed_methods.includes(x._[1]) || x._[2] === undefined) {
        return createStderr('Invalid Usage: systemctl [action] [service]');
      }

      if (x._[2] !== 'httpd') {
        return createStderr(`Service ${x._[2]} Does Not Exist`);
      }

      if (x._[1] === 'start') {
        if (this.completion.step1 === false) {
          return createStderr(`Service ${x._[2]} Does Not Exist`);
        }
        this.completion.step2 = true;
        return createStdout(`Service ${x._[2]} Started`);
      }

      if (x._[1] === 'enable') {
        if (this.completion.step1 === false) {
          return createStderr(`Service ${x._[2]} Does Not Exist`);
        }
        if (this.completion.step2 === false) {
          return createStderr(`Service ${x._[2]} Is Not Started`);
        }
        this.completion.step3 = true;
        return createStdout(`Service ${x._[2]} Enabled`);
      }

      if (x._[1] === 'status') {
        if (this.completion.step1 === false) {
          return createStderr(`Service ${x._[2]} Does Not Exist`);
        }
        if (this.completion.step2 === false) {
          return createStderr(`Service ${x._[2]} Is Not Started`);
        }
        if (this.completion.step3 === false) {
          return createStderr(`Service ${x._[2]} Is Not Enabled`);
        }
        this.completion.step4 = true;

        setTimeout(() => {
          this.$emit('simulation_full_correct', 1);
        }, 750);

        return createStdout(
          'httpd.service - The Apache HTTP Server<br>Loaded: loaded (/usr/lib/systemd/system/httpd.service; enabled; vendor preset: disabled)<br>Active: active (running)<br>Main PID: 17981 (httpd)<br>Status: "Total requests: 0"<br>AH00558: httpd: Could not reliably determine the server\'s fully qualified domain name',
        );
      }

      return createStdout('Invalid Usage: systemctl [action] [service]');
    };
  },
};
</script>
